import { render, staticRenderFns } from "./SnowdownFighter.vue?vue&type=template&id=6170c7f7&scoped=true"
import script from "./SnowdownFighter.vue?vue&type=script&lang=js"
export * from "./SnowdownFighter.vue?vue&type=script&lang=js"
import style0 from "./SnowdownFighter.vue?vue&type=style&index=0&id=6170c7f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170c7f7",
  null
  
)

export default component.exports